<mat-dialog-content>
  <div class="confirmation-dialog-container">
    <h1>{{ data.confirmationText }}</h1>
    <p *ngIf="data.confirmationNote">{{ data.confirmationNote }}</p>
    <div class="action-buttons">
      <button *ngIf="!data.hideDecline" mat-button (click)="onDecline()">
        {{ data.cancelText || 'No' }}
      </button>
      <button mat-button cdkFocusInitial (click)="onAccept()" color="primary">
        {{ data.acceptText || 'Yes' }}
      </button>
    </div>
  </div>
</mat-dialog-content>
